module.exports = "/public/images/41fd3726a2c0a45bf9a1150705ca9dca.png";